let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f8r36")).then(() => parcelRequire('7LA0I'));